import React, { useState, useEffect } from 'react';
import { 
  Typography, Paper, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Button, Box, IconButton
} from '@mui/material';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const SellersList = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSellers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/sellers');
      setSellers(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching sellers:', err);
      setError('Virhe myyjien haussa. Yritä myöhemmin uudelleen.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSellers();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Haluatko varmasti poistaa tämän myyjän?')) {
      try {
        await api.delete(`/api/sellers/${id}`);
        // Refresh the list after deletion
        fetchSellers();
      } catch (err) {
        console.error('Error deleting seller:', err);
        setError('Virhe myyjän poistossa. Yritä myöhemmin uudelleen.');
      }
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Myyjät
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          component={Link} 
          to="/sellers/new"
          startIcon={<AddIcon />}
        >
          Uusi myyjä
        </Button>
      </Box>

      {error && (
        <Paper sx={{ p: 2, mb: 2, bgcolor: '#ffebee' }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      )}

      {loading ? (
        <Typography>Ladataan myyjiä...</Typography>
      ) : sellers.length === 0 ? (
        <Paper sx={{ p: 3 }}>
          <Typography>Ei myyjiä. Luo uusi myyjä aloittaaksesi.</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nimi</TableCell>
                <TableCell>Sähköposti</TableCell>
                <TableCell>Puhelin</TableCell>
                <TableCell>Toiminnot</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sellers.map((seller) => (
                <TableRow key={seller.id}>
                  <TableCell>{seller.name}</TableCell>
                  <TableCell>{seller.email || '-'}</TableCell>
                  <TableCell>{seller.phone || '-'}</TableCell>
                  <TableCell>
                    <IconButton 
                      component={Link} 
                      to={`/sellers/edit/${seller.id}`}
                      color="primary"
                      size="small"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton 
                      onClick={() => handleDelete(seller.id)}
                      color="error"
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default SellersList;
